module.exports = __webpack_public_path__ + "img/logo.c41d5a7f.png";